import Link from "next/link";
import { PackageCheck } from "@/components/icons";
import type { Id } from "@convex/_generated/dataModel";
import { Button } from "@/components/ui/button";

export function ListingOwnerActionCard({
  productId,
}: {
  productId: Id<"products">;
}) {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <div className="flex size-10 items-center justify-center rounded-full bg-brand-tint">
        <PackageCheck className="size-5 text-brand-strong" aria-hidden="true" />
      </div>
      <div className="space-y-1">
        <h2 className="text-sm font-semibold text-foreground">
          This is your listing
        </h2>
      </div>
      <Button asChild variant="primary" className="w-full">
        <Link href={`/dashboard/inventory/${productId}/edit`}>Edit listing</Link>
      </Button>
    </div>
  );
}
